import alloy from '@alloyidentity/web-sdk';

interface AlloySDKData {
  journey_application_status: 'Denied' | 'Approved';
  status: 'completed';
}

type MockAlloy = typeof alloy;

export const NEURO_SITE_ID_MOCK = 'foobarbaz';
export const NUERO_USER_ID_MOCK = 'gordon.freeman@blackmesa.gov';
export const IOVATION_BLACKBOX_ID_MOCK = 'blackbox-id-mock';

export const mockAlloy: MockAlloy = {
  init: (_: unknown) => {
    return Promise.resolve({
      neuroIdSiteId: NEURO_SITE_ID_MOCK,
      neuroUserId: NUERO_USER_ID_MOCK,
      iovationBlackboxId: IOVATION_BLACKBOX_ID_MOCK,
    });
  },
  preload: (_?: string) => {
    // noOp
  },
  open: (cb: (data: unknown) => void, anchorElement?: string) => {
    const container = document.getElementById(anchorElement || '');
    if (!container) {
      throw new Error('Could not find container for mock alloy!');
    }

    const buttonClasses = [
      'button-text-theme-primary',
      'bg-theme-primary',
      'border',
      'button-border-theme-primary',
      'm-2',
      'font-bold',
      'p-2',
      'drop-shadow-[0_5px_0px_rgba(78,92,111,0.25)]',
    ];
    const approvedButtonElement = document.createElement('button');
    approvedButtonElement.classList.add(...buttonClasses);
    approvedButtonElement.setAttribute('data-cy', 'alloy-simulate-approved');
    approvedButtonElement.textContent = 'Simulate Approved';
    approvedButtonElement.addEventListener('click', () => {
      const d: AlloySDKData = {
        journey_application_status: 'Approved',
        status: 'completed',
      };
      cb(d);
    });

    const deniedButtonElement = document.createElement('button');
    deniedButtonElement.classList.add(...buttonClasses);
    deniedButtonElement.setAttribute('data-cy', 'alloy-simulate-denied');
    deniedButtonElement.textContent = 'Simulate Denied';
    deniedButtonElement.addEventListener('click', () => {
      const d: AlloySDKData = {
        journey_application_status: 'Denied',
        status: 'completed',
      };
      cb(d);
    });

    const unknownButtonElement = document.createElement('button');
    unknownButtonElement.classList.add(...buttonClasses);
    unknownButtonElement.setAttribute('data-cy', 'alloy-simulate-unknown');
    unknownButtonElement.textContent = 'Simulate Unknown';
    unknownButtonElement.addEventListener('click', () => {
      const d = {
        foo: 'bar',
        baz: true,
        num: 8675309,
      };
      cb(d);
    });

    container.append(approvedButtonElement);
    container.append(deniedButtonElement);
    container.append(unknownButtonElement);
  },
  close: () => {
    // noOp
  },
  createJourneyApplication: (_: unknown) => {
    return Promise.resolve();
  },
  createEvaluation: (_: unknown) => {
    return Promise.resolve();
  },
  getPublicUrl: () => '',
};
